import { Button, Input, Space, Typography } from "antd";
import React, { useState } from "react";

const { Search } = Input;
const { Text } = Typography;

const UsersToolbar = ({
  filters,
  onFiltersChange,
  onAddUser,
  showFilters,
  showAddUser,
}) => {
  const [searchKeyword, setSearchKeyword] = useState(
    filters.searchKeyword || ""
  );

  return (
    <>
      <Space
        style={{
          width: "100%",
          marginBottom: "1.25rem",
          justifyContent: showFilters ? "space-between" : "flex-end",
        }}
        direction="horizontal"
        align="end"
        wrap
      >
        <Space align="end" wrap>
          {showFilters && (
            <>
              <Space direction="vertical">
                <Text>Search Email</Text>
                <Search
                  allowClear
                  placeholder="Search"
                  value={searchKeyword}
                  onChange={(event) => setSearchKeyword(event.target.value)}
                  onSearch={(value) => {
                    onFiltersChange("searchKeyword", value);
                  }}
                  enterButton
                  style={{ width: "350px" }}
                />
              </Space>
            </>
          )}

          {showAddUser && (
            <Button type="primary" onClick={onAddUser}>
              Add User
            </Button>
          )}
        </Space>
      </Space>
    </>
  );
};

export default UsersToolbar;
